export const urlImageBase = "/assets/images/";

export class RefSettings {
	ref_id: number | null = null;
	bo_showed?: boolean = false;
	default_color?: string = "#ffc844";
	logo_header?: string = urlImageBase + "logo_KT.svg";
	logo_header_sidebar?: string = urlImageBase + "logo_KT.svg";
	loader?: string = urlImageBase + "loader.gif";
	back_url?: string = "/";
	default_font?: string = "Raleway";
	secondary_font?: string = "Caveat";
	other_font?: string = "Caveat Brush";
	width_logo?: string = "130";
	use_permissions?: boolean = false;
}
